import React, { useState } from 'react';
import GatewayStatus from './diagnostics/GatewayStatus';
import PaymentSimulator from './diagnostics/PaymentSimulator';
import PaymentLogViewer from './diagnostics/PaymentLogViewer';
import SystemAudit from './diagnostics/SystemAudit';
import AdminPaymentTransactions from './AdminPaymentTransactions'; // Reused Advanced Explorer

const AdminPaymentDiagnostics = () => {
  const [activeTab, setActiveTab] = useState('status');

  const tabs = [
    { id: 'status', label: 'Gateway Status' },
    { id: 'simulator', label: 'Payment Simulation' },
    { id: 'explorer', label: 'Transaction Explorer' },
    { id: 'logs', label: 'Log Viewer' },
    { id: 'audit', label: 'System Audit' }
  ];

  return (
    <div className="space-y-6 pb-12">
      <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm mb-6">
        <h2 className="text-2xl font-serif text-gray-800 mb-2">Payment Testing & Diagnostics Center</h2>
        <p className="text-sm text-gray-500">Validate the complete Marx IPG infrastructure, monitor health, and ensure production readiness.</p>
      </div>

      <div className="flex gap-2 border-b border-gray-200 overflow-x-auto hide-scrollbar">
        {tabs.map(tab => (
          <button 
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`pb-4 px-4 font-bold text-sm uppercase tracking-wider transition-colors whitespace-nowrap ${activeTab === tab.id ? 'border-b-2 border-brand-gold text-brand-darkSage' : 'text-gray-400 hover:text-gray-700'}`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="pt-4">
        {activeTab === 'status' && <GatewayStatus />}
        {activeTab === 'simulator' && <PaymentSimulator />}
        {activeTab === 'explorer' && <AdminPaymentTransactions />}
        {activeTab === 'logs' && <PaymentLogViewer />}
        {activeTab === 'audit' && <SystemAudit />}
      </div>
    </div>
  );
};

export default AdminPaymentDiagnostics;